import type { TOrderType } from 'app/helpers/parseQueryParamOrder';

export const repositoryJobsListDefaults: { pageSize: number; orderBy: string; orderType: TOrderType } = {
  pageSize: 25,
  orderBy: 'createdAt',
  orderType: 'desc',
};
